<div class="w100 row space-between align-center">
    <h2>Edit User Gates</h2>
    <rr-btn type="Primary" iconStart="add" size="Small" (click)="createGate()"
        >Add Gate</rr-btn
    >
</div>
<div class="col w100 grow-1 gap-24 gatarea">
    @for (conf of gateList; track conf) {
        <div class="col w100 gap-8 card">
            @if (showAddStream && addingGate === conf.orderNr) {
                <div class="w100 col">
                    <div class="">Select a Stream</div>
                    <div class="row w100 gap-8 space-between align-center">
                        <rr-select
                            class="w100"
                            [options]="streamList"
                            optionValue="id"
                            optionName="name"
                            [control]="selectedStreamId"
                            (change)="addStreamToGate()"
                        ></rr-select>
                        <rr-btn type="Tertiary" (click)="closeAddStream()"
                            >Close</rr-btn
                        >
                    </div>
                </div>
            }
            <div class="row w100 space-between align-center gap-8">
                <rr-input [(ngModel)]="conf.name"></rr-input>
                <rr-btn
                    type="Link"
                    iconStart="add"
                    (click)="addStreamClick(conf.orderNr)"
                >
                    Add Stream</rr-btn
                >
            </div>
            <div class="w100 col gap-4 stream-wrapper">
                @for (
                    stream of conf.streamIdList;
                    track stream;
                    let i = $index
                ) {
                    <div class="w100 row align-center space-between">
                        <div>{{ stream.streamName }}</div>
                        <rr-btn
                            type="Link"
                            iconStart="trash"
                            (click)="removeStreamClick(conf.orderNr, i)"
                        ></rr-btn>
                    </div>
                } @empty {
                    <div class="row space-between gap-8 align-center">
                        No streams selected.
                        <rr-btn type="Link" (click)="removeGate(conf.orderNr)"
                            >Remove Gate</rr-btn
                        >
                    </div>
                }
            </div>
        </div>
    } @empty {
        <div class="col w100 h100 grow-1 align-center justify-center">
            <div>No Gate configured.</div>
            <rr-btn type="Primary" size="Medium" (click)="createGate()"
                >+ Add Gate</rr-btn
            >
        </div>
    }
</div>
<div class="w100 gap-8 justify-end row">
    <rr-btn type="Secondary" (click)="close()">Cancel</rr-btn>
    <rr-btn type="Primary" (click)="save()" [disabled]="gateList.length === 0"
        >Add to Invite-Link</rr-btn
    >
</div>
